if (!customElements.get("testimonials-carousel")) {
  class TestimonialsCarousel extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.options = JSON.parse(this.getAttribute("data-swiper-options")) || {};
      this.swiperEl = this.querySelector(".js-tc-swiper");

      this.waitForSwiper().then(() => {
        this.initSlider();
      });

      window.addEventListener("shopify:section:load", () => {
        this.initSlider();
      });
    }

    waitForSwiper() {
      return new Promise((resolve) => {
        if (typeof Swiper !== "undefined") {
          resolve();
          return;
        }
        const check = setInterval(() => {
          if (typeof Swiper !== "undefined") {
            clearInterval(check);
            resolve();
          }
        }, 50);
      });
    }

    initSlider() {
      if (!this.swiperEl) {
        console.warn("[TC] .js-tc-swiper element not found");
        return;
      }

      if (this.slider) {
        this.slider.destroy(true, true);
      }

      const opts = this.options;

      const paginationEl = this.querySelector(".js-tc-pagination");
      const prevBtn = this.querySelector(".js-tc-prev");
      const nextBtn = this.querySelector(".js-tc-next");

      const sliderOptions = {
        slidesPerView: opts.slidesPerViewMobile || 1.2,
        spaceBetween: opts.spaceBetweenMobile ?? 16,
        loop: opts.loop || false,
        autoplay: opts.autoplay || false,
        observer: true,
        observeParents: true,
        pagination: paginationEl
          ? { el: paginationEl, clickable: true }
          : false,
        navigation:
          prevBtn && nextBtn
            ? { prevEl: prevBtn, nextEl: nextBtn }
            : false,
        breakpoints: {
          750: {
            slidesPerView: opts.slidesPerViewTablet || 2,
            spaceBetween: opts.spaceBetweenDesktop ?? 24
          },
          990: {
            slidesPerView: opts.slidesPerViewDesktop || 3,
            spaceBetween: opts.spaceBetweenDesktop ?? 24
          }
        }
      };

      this.slider = new Swiper(this.swiperEl, sliderOptions);
    }

    disconnectedCallback() {
      if (this.slider) {
        this.slider.destroy(true, true);
      }
    }
  }

  customElements.define("testimonials-carousel", TestimonialsCarousel);
}
